var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.notes,"dense":"","hide-default-footer":true,"disable-pagination":true,"no-data-text":"No notes","show-expand":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }